import { getSoundSettings } from './soundEffectsManager';

/**
 * Simple utility for playing sound effects
 * Sound effects are short, one-time sounds that don't need caching
 * Uses global sound settings from soundEffectsManager
 * 
 * @param {string} soundPath - Path to the sound file (e.g., '/sounds/click.mp3')
 * @param {number} overrideVolume - Optional volume override (0.0 to 1.0). If not provided, uses global setting.
 */
export function playSoundEffect(soundPath, overrideVolume = null) {
  if (!soundPath) return;
  
  // MOBILE FIX: Don't play sounds when page is hidden (screen locked)
  if (typeof document !== 'undefined' && document.hidden) {
    return;
  }
  
  const { soundsEnabled, soundsVolume } = getSoundSettings();
  
  if (!soundsEnabled) return;
  
  const volume = overrideVolume !== null ? overrideVolume : soundsVolume;
  
  try {
    const audio = new Audio(soundPath);
    audio.volume = volume;
    audio.play().catch(err => {
      // Silently fail if audio can't play (e.g., user hasn't interacted with page yet)
      console.debug('Sound effect play failed:', err);
    });
  } catch (error) {
    console.debug('Sound effect error:', error);
  }
}

